//mobile ready
import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import "./carousel.css";

const MyCarousel = () => {
  const slides = [
    {
      src: "assets/michael-demoya-J99pG-3RHwc-unsplash.jpg",
      caption: "Your looks will get a second look with Our Grooming",
    },
    {
      src: "assets/rafaella-mendes-diniz-et_78QkMMQs-unsplash.jpg",
      caption: "Your Satisfaction is our Motto",
    },
    {
      src: "assets/adam-winger-WDmvpGs2060-unsplash.jpg",
      caption: "You will come back again",
    },
  ];

  return (
    <Carousel
      interval={5000}
      infiniteLoop
      autoPlay
      showThumbs={false}
      showStatus={false}
      showArrows={true}
      swipeable
      emulateTouch
    >
      {slides.map((slide, index) => (
        <div key={index} className="carousel-slide">
          <img
            src={slide.src}
            alt={`Slide ${index + 1}`}
            className="carousel-image"
          />
          <p className="legend carousel-caption">{slide.caption}</p>
        </div>
      ))}
    </Carousel>
  );
};

export default MyCarousel;







// original before mobile ready
// https://www.npmjs.com/package/react-responsive-carousel

// import React, { Component } from 'react';
// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from 'react-responsive-carousel';
// import './carousel.css'

// class MyCarousel extends Component {
//   render() {
//     return (
//       <Carousel interval={5000} infiniteLoop={true} showThumbs={false} autoPlay={true}>


//         <div>
//           <img src="assets/michael-demoya-J99pG-3RHwc-unsplash.jpg" alt="No img" style={{ height: '540px' }} className="myCarousel" />
//           <p className="legend " style={{ fontSize: 30, color: '#fb6a33', paddingBottom: '16px' }}>Your looks will get a second look with Our Grooming</p>
//         </div>
//         <div>
//           <img src="assets/rafaella-mendes-diniz-et_78QkMMQs-unsplash.jpg" alt="No img" style={{ height: '540px' }} className="myCarousel" />
//           <p className="legend" style={{ fontSize: 30, color: '#fb6a33' }}>Your Satisfaction is our Motto</p>
//         </div>
//         <div>
//           <img src="assets/adam-winger-WDmvpGs2060-unsplash.jpg" alt="No img" style={{ height: '540px' }} className="myCarousel" />
//           <p className="legend" style={{ fontSize: 30, color: '#fb6a33' }}>You will come back again</p>
//         </div>

//       </Carousel >
//     );
//   }
// }

// export default MyCarousel